import { t as e } from "../../constants-B7fXbm2f.js";
import { t } from "../../_plugin-vue_export-helper-B52Kst-M.js";
import { createElementBlock as n, createElementVNode as r, normalizeClass as i, openBlock as a } from "vue";
//#region ../src/icons/facebook.vue
var o = {
	name: "DtIconFacebook",
	props: {
		size: {
			type: String,
			default: "500",
			validator: (t) => Object.keys(e).includes(t)
		},
		ariaLabel: {
			type: String,
			default: void 0
		}
	},
	emits: ["loaded"],
	computed: {
		iconSizeClass() {
			return e[this.size];
		},
		ariaHidden() {
			return this.ariaLabel ? "false" : "true";
		},
		dataQA() {
			return this.$attrs["data-qa"] ?? "dt-icon";
		}
	},
	created() {
		this.$emit("loaded");
	}
}, s = [
	"aria-label",
	"data-qa",
	"aria-hidden"
];
function c(e, t, o, c, l, u) {
	return a(), n("svg", {
		"aria-label": o.ariaLabel,
		class: i([u.iconSizeClass, "d-icon d-icon--facebook"]),
		"data-qa": u.dataQA,
		"aria-hidden": u.ariaHidden,
		role: "img",
		"data-name": "Facebook",
		viewBox: "0 0 24 24",
		xmlns: "http://www.w3.org/2000/svg"
	}, [...t[0] || (t[0] = [r("path", {
		d: "M20.978 11.989a8.989 8.989 0 1 0-10.394 8.88v-6.282H8.302V11.99h2.282v-1.98c0-2.253 1.342-3.498 3.396-3.498.983 0 2.012.176 2.012.176V8.9h-1.134c-1.117 0-1.465.693-1.465 1.404v1.686h2.493l-.398 2.598h-2.095v6.281c4.297-.674 7.585-4.393 7.585-8.88",
		fill: "#1877F2"
	}, null, -1), r("path", {
		d: "m15.488 14.587.398-2.598h-2.493v-1.686c0-.711.348-1.404 1.465-1.404h1.134V6.687s-1.03-.176-2.013-.176c-2.053 0-3.395 1.245-3.395 3.497v1.98H8.302v2.6h2.282v6.28a9.036 9.036 0 0 0 2.81 0v-6.28h2.094Z",
		fill: "#fff"
	}, null, -1)])], 10, s);
}
var l = /* @__PURE__ */ t(o, [["render", c]]);
//#endregion
export { l as default };

//# sourceMappingURL=facebook.js.map